export const build = { date:"2026-07-28.1430", stage:"alpha" }
